export enum Cookies {
  'COMMERCE_LAYER_BASKET_ID_COOKIE' = 'COMMERCE_LAYER_BASKET_ID_COOKIE',
  'STORE_SETTINGS_COOKIE' = 'STORE_SETTINGS_COOKIE',
  'HIDE_NEWSLETTER_POPUP_COOKIE' = 'HIDE_NEWSLETTER_POPUP_COOKIE',
}
